import z from 'zod'

export const NameSchema = z
  .string()
  .min(3, 'Name must be at least 3 characters long')
